import { getFrontDomain } from "utils/api";

class CommentsService {
  sendComment = async (comment) => {
    const result = await fetch(`${getFrontDomain()}/api/comment`, {
      method: "POST",
      body: JSON.stringify(comment),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .catch((error) => console.log(error)); // eslint-disable-line no-console

    return result;
  };

  getComments = async (uuid = "") => {
    const result = await fetch(`${getFrontDomain()}/api/comment/${uuid}`, {
      method: "GET",
      credentials: "same-origin",
    }).then((res) => res.json());
    return Object.values(result);
  };
}

const service = new CommentsService();
export default service;
